
import { mixins, Options } from "vue-class-component";
import { CargoController } from "@/app/ui/controllers/CargoController";
import ListCargoType from "@/app/ui/views/cargo/booking-cargo/second-step/list-cargo-type.vue";
import CargoTypeCard from "@/app/ui/views/cargo/booking-cargo/components/cargo-type-card.vue";
import { getTokenNGen } from "@/app/infrastructures/misc/Cookies";
import { NGenController } from "@/app/ui/controllers/NGenController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { OptionsClass } from "@/domain/entities/MainApp";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { firstCapitalize, storeDatatoSessionStorage, parseByCountry } from "@/app/infrastructures/misc/Utils";
import { AirportData, CargoDetailSttPiece, DimensionPerKoliData, DimensionPerKoliDetail } from "@/domain/entities/Cargo";
import { ReadyToCargoController } from "@/app/ui/controllers/ReadyToCargoController";
import CargoPlaneAutoV2 from "../v2/CargoPlaneAutoV2";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import { flags } from "@/feature-flags";
import { getConfigDimensionDivider, CALCULATE_TYPE, getConfigIsminimumVolumePerPiece, getConfigMinimumVolumePerPiece } from "../../modules/cargo-module";
import { CalculateVolumeApiRequest, CalculateVolumeRequest } from '@/data/payload/api/CargoApiRequest';

@Options({
  emits: "closeModal",
  components: { ListCargoType, CargoTypeCard }
})
export default class ModalCargoType extends mixins(CargoPlaneAutoV2) {
  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  async mounted() {
    this.searchCargo();
    CargoController.setShowSelectAirport(false);
    CargoController.setShowSelectAirportToLocalStorage(false);
  }

  showInfoDividerCargo = true;

  unmounted() {
    CargoController.setShowModalCargoType(false);
  }

  cargoType = "";
  cargoTypeStatus = "";
  isDisableButton = true;

  get showModalCargoType() {
    return CargoController.showModalCargoType;
  }

  get readyToCargoDetail() {
    return CargoController.readyToCargoDetail;
  }

  get formCargo() {
    return CargoController.form;
  }

  get titleButtonDialog() {
    return this.isEditReadyToCargo
      ? "Ubah Transportasi"
      : "Simpan transportasi";
  }

  get titleDialog() {
    return this.isEditReadyToCargo ? "Ubah Kargo" : "Pilih kargo";
  }

  get isEditReadyToCargo() {
    return CargoController.isEditReadyToCargo;
  }

  searchCargo() {
    CargoController.getCargoOptions({
      origin: {
        code:
          this.readyToCargoDetail.originCode ||
          AccountController.accountData.account_location.city_code ||
          "",
        name:
          this.readyToCargoDetail.originName ||
          AccountController.accountData.account_location.city_name ||
          ""
      },
      destination: {
        code:
          this.readyToCargoDetail.destinationCode ||
          this.formCargo.destinationCityCode ||
          "",
        name:
          this.readyToCargoDetail.destinationName ||
          this.formCargo.destinationCityName ||
          ""
      },
      isPlaneManual: true
    });
  }
  cancelModalCargoType() {
    CargoController.setShowModalCargoType(false);
    CargoController.setShowSelectAirport(false);
    CargoController.setShowSelectAirportToLocalStorage(false);
  }

  // airport
  airportMappingData(data: AirportData[]) {
    return data.map(airport => ({
      ...airport,
      name: `${airport.airportCode} - ${airport.airportName}`,
      value: airport.airportCode
    }));
  }
  get optionAirportDestination() {
    return this.airportMappingData(CargoController.airportDataDestination.data);
  }

  selectCargoType(type: string, status: string) {
    this.cargoType = type;
    CargoController.setIsBookingAuto(status === "auto");
    this.cargoTypeStatus = status;
    this.isDisableButton = false;
    this.form.airportOrigin.airportCode = this.originCity.code || ""
    this.initPlaneAuto();
    this.form.transit = "0"
    CargoController.form.airports = [];
  }

  get isPlaneAuto() {
    return this.cargoType === "plane" && this.cargoTypeStatus === "auto";
  }
  get isPlaneManual() {
    return this.cargoType === "plane" && this.cargoTypeStatus === "manual";
  }
  get isPlane() {
    return this.cargoType === "plane";
  }
  async onCheckAuthNGen(): Promise<void> {
    if (!getTokenNGen()) {
      await NGenController.onLoginNGen();
    }
  }

  async initPlaneAuto(): Promise<void> {
    await this.fetchAirportOrigin(this.originCity.code || "");
    await this.fetchAirportDestination(this.form.destinationCityCode);
  }
  get form() {
    return CargoController.form;
  }
  fetchAirportOrigin(search: string) {
    search = search || "";
    search = search.split(" - ").length > 1 ? search.split(" - ")[1] : search;
    return CargoController.getAirportListOrigin({
      airportCode: "",
      cityCode: search,
      page: 1,
      limit: 10,
      isLocation: false
    });
  }
  fetchAirportDestination(search: string) {
    search = search || "";
    search = search.split(" - ").length > 1 ? search.split(" - ")[1] : search;
    return CargoController.getAirportListDestination({
      airportCode: "",
      cityCode: search,
      page: 1,
      limit: 10
    });
  }

  // origin city
  get originCity(): OptionsClass {
    const detailDistrict = LocationController.districtDetail;
    return new OptionsClass({
      name: `${detailDistrict.cityCode} - ${firstCapitalize(
        detailDistrict.cityName.toLowerCase()
      )}`,
      code: detailDistrict.cityCode
    });
  }

  get flowBooking() {
    return ReadyToCargoController.flowBooking;
  }

  get totalPcs() {
   return this.form.actualTotalSTTPieces;
  }
  setFilFormManualBooking() {
    if (this.isPlaneManual) {
      CargoController.setFillForm(false);
    } else {
      CargoController.setFillForm(true);
    }
  }

  async changeCargoType() {
    const isDifferentCargoType = this.cargoType !== CargoController.form.cargoType;
    if (this.cargoType) {
      CargoController.setOnChangeVehicleNumber("");
      if(this.flowBooking.includes("rtc") && this.isPlaneAuto) {
        storeDatatoSessionStorage('backup-flight-rtc', this.form.flightsData);
      }
      CargoController.form.cargoType = this.cargoType;
      CargoController.form.cargoTypeStatus = this.cargoTypeStatus;
      CargoController.setIsChangeCargoType(true);
      this.setFilFormManualBooking()
      if (this.isPlaneAuto) {
        this.onCheckAuthNGen();
        CargoController.setProgressValue(0);   
      } else if (!this.isEditReadyToCargo && (this.flowBooking === "manual")) {
        CargoController.setProgressValue(2);
      }
    }
    if (!this.isPlaneAuto || getTokenNGen()) {
      CargoController.setShowModalCargoType(false);
    }
    this.updateDimensionPerKoli();
    const cargoType = {
      type: this.cargoType,
      status: this.cargoTypeStatus
    };
    CargoController.setCargoType(cargoType);
    if (isDifferentCargoType) {
      this.calculateVolume(CALCULATE_TYPE.CHANGE_MODA);
    }
    // if(!this.isChangeVolume) CargoController.calculationVolumeWeight(this.totalPcs);
  }

  private parseNumber(value: string) {
    if (typeof value === "number") return value;
    return value ? parseByCountry(value, { country: this.countryCode }) : 0;
  }

  get cargoInputForm() {
    return CargoController.cargoInputForm;
  }

  get isFromRebookingRTC() {
    return CargoController.isRebookingFromRTC;
  }

  get isChangeVolume() {
    return CargoController.isChangeVolumeActual;
  }

  async updateDimensionPerKoli() {
    const isRebooking = CargoController.cargoDetailData.id;
    const isDimensiPerKoli = CargoController.cargoDetailData.isCargoDimensionOn;

    if (isRebooking && !isDimensiPerKoli) return;

    CargoController.setDimensionPerKoliData(new DimensionPerKoliData());

    // Extract total pieces and dimension pieces from CargoController
    const { dimensionPieces } = CargoController.dimensionPerKoliData;

    // Create a new data array by mapping over existing data
    const tableData = CargoController.sttResultFinal;
    const mappingKoliData = await tableData.flatMap(
      (item: any) =>
        item.baggingNumber && this.hasBagDimensions(item.bagData)
          ? [this.createBagDimensionDetail(item)] // Create bag dimension details if dimensions exist
          : this.createPieceDimensionDetails(item) // Create piece dimension details otherwise
    );

    // Update dimension per koli details with existing and new data
    const updatedDimensionPerKoli: DimensionPerKoliDetail[] = mappingKoliData
      .map((newItem: DimensionPerKoliDetail) => {
        const existing = dimensionPieces.find(
          (item: DimensionPerKoliDetail) => item.sttOrBag === newItem.sttOrBag
        );
        return existing ? existing : newItem;
      })
      .filter(Boolean);

    // Set the updated dimension per koli data to CargoController
    CargoController.setDimensionPerKoliData(
      new DimensionPerKoliData({
        dimensionPieces: updatedDimensionPerKoli
      })
    );
  }

  hasBagDimensions(bag: any): boolean {
    return !!(
      bag?.bagCustomLength &&
      bag?.bagCustomWidth &&
      bag?.bagCustomHeight
    );
  }
  private getBagId(item: any): string {
    return item.baggingVendorNo || item.baggingNumber;
  }

  private getBagDimensions(bagData: any) {
    return {
      length: bagData?.bagCustomLength,
      width: bagData?.bagCustomWidth,
      height: bagData?.bagCustomHeight,
      grossWeight: bagData?.bagCustomGrossWeight
    };
  }

  createBagDimensionDetail(item: any): DimensionPerKoliDetail {
    const bagDimensions = this.getBagDimensions(item.bagData);

    return new DimensionPerKoliDetail({
      sttOrBag: this.getBagId(item),
      sttPieceGrossWeight: bagDimensions.grossWeight,
      sttPieceVolumeWeight: this.calculateVolumeWeight(
        bagDimensions.length,
        bagDimensions.width,
        bagDimensions.height
      ),
      sttPieceLength: bagDimensions.length,
      sttPieceWidth: bagDimensions.width,
      sttPieceHeight: bagDimensions.height
    });
  }
  createPieceDimensionDetails(item: any) {
    return item?.sttPieces?.length
      ? item.sttPieces.map(
          (piece: CargoDetailSttPiece, index: number) =>
            new DimensionPerKoliDetail({
              sttOrBag: `${item.sttNumber} #${index + 1}`,
              sttPieceGrossWeight: piece.sttPieceGrossWeight,
              sttPieceVolumeWeight: this.calculateVolumeWeight(
                piece.sttPieceLength,
                piece.sttPieceWidth,
                piece.sttPieceHeight
              ),
              sttPieceLength: piece.sttPieceLength,
              sttPieceWidth: piece.sttPieceWidth,
              sttPieceHeight: piece.sttPieceHeight
            })
        )
      : [];
  }
  calculateVolumeWeight(length: number, width: number, height: number): number {
    const divider = getConfigDimensionDivider(this.cargoType);
    return (length * width * height) / divider;
  }

  get totalNewCalculationGrossWeights() {
    return CargoController.totalNewCalculationGrossWeights;
  }

  get totalNewCalculationVolumeWeights() {
    return CargoController.totalNewCalculationVolumeWeights;
  }

  async calculateVolume(calculateType = ""){
    await this.$nextTick();
    CargoController.calculateVolume(new CalculateVolumeApiRequest({
      calculateType,
      calculateRequest: new CalculateVolumeRequest({
        cargoType: this.form.cargoType,
        chargeableWeightReweigh: Math.max(
          1,
          CargoController.totalNewCalculationGrossWeights,
          CargoController.totalNewCalculationVolumeWeights
        ),
        currentGrossWeight: this.parseNumber(this.form.actualTotalCargoGrossWeight),
        height: this.form.actualDimension.height,
        length: this.form.actualDimension.length,
        width: this.form.actualDimension.width,
        totalPieces: this.form.actualTotalSTTPieces,
        volumeWeightReweigh: CargoController.totalNewCalculationVolumeWeights,
        divider: getConfigDimensionDivider(this.form.cargoType),
        isMinimumVolumePerPiece: getConfigIsminimumVolumePerPiece(this.form.cargoType, this.form.cargoTypeStatus),
        minVolumePerPiece: getConfigMinimumVolumePerPiece(this.form.cargoType, this.form.cargoTypeStatus)
      })
    }))
  }
}
